import styled from 'styled-components';

export const SectionWrap = styled.div ``;
